import { Spinner as ChakraSpinner, type SpinnerProps as ChakraSpinnerProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraSpinnerProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraSpinner ref={ref} {...props} />
})
